import { FetchRequest } from "./fetchRequest";

export interface IRequestOnMonetizationStatus {
  pubID: number;
  frequency: string;
  content: string;
}

class MonetizationRequestStatus {
  requestOnMonetizationStatus = async (
    payload: IRequestOnMonetizationStatus
  ) => {
    // @ts-ignore
    return await FetchRequest({
      url: `/ssp/monetization/iwant`,
      method: "POST",
      useToken: true,
      body: payload,
    });
  };
}

export const MonetizationRequestStatusApi = new MonetizationRequestStatus();
